import {
  ExpressCheckoutAuthResponse,
  ExpressCheckoutUserData,
  Payment,
} from './types';

export function normalizePaymentMethods(
  data: ExpressCheckoutAuthResponse,
): ExpressCheckoutUserData | null {
  if (!data.payments || !data.payments.length) {
    return null;
  }
  const lastUsedPayment = data.payments.find(
    method => method.isLastUsedPaymentMethod,
  );
  const payPal = data.payments.find(method => method.key === Payment.PAYPAL);
  const payment = lastUsedPayment || payPal;
  if (!payment) {
    throw new Error(
      'Cannot find a last used payment method nor PayPal. One of both is always expected. Make sure to include them within the response of the API.',
    );
  }
  return {
    ...data,
    payment,
  };
}
